import cn from "classnames";
import { ReactComponent as CoinIcon } from "@assets/svg/coin.svg";
import CountUp from "react-countup";
import styles from "./panel.module.scss";

export interface IHeadProps {
  title: string;
  bank: number;
  className?: string;
}

const Head = ({ title, bank, className = "" }: IHeadProps): JSX.Element => {
  const classes = cn(styles.head__bank, className);

  return (
    <div className={styles.head}>
      <span className={styles.head__title}>{title}</span>
      <div className={classes}>
        <span>
          <CoinIcon style={{ marginRight: "0.3rem" }} />
          <CountUp end={bank / 100} duration={1} />
        </span>
      </div>
    </div>
  );
};

export default Head;
